import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Product } from './components/Product';
import { Pricing } from './components/Pricing';
import { Trust } from './components/Trust';
import { Closing } from './components/Closing';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full overflow-x-hidden selection:bg-ember/20 selection:text-charcoal" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Product data-id="element-3" />
      <Pricing data-id="element-4" />
      <Trust data-id="element-5" />
      <Closing data-id="element-6" />
    </div>;
}